'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _reactMasonryComponent = require('react-masonry-component');

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _viewport = require('../viewport/viewport');

var _viewport2 = _interopRequireDefault(_viewport);

var _content = require('../content/content');

var _content2 = _interopRequireDefault(_content);

var _boothBackground = require('./booth-background');

var _boothBackground2 = _interopRequireDefault(_boothBackground);

var _boothShade = require('./booth-shade');

var _boothShade2 = _interopRequireDefault(_boothShade);

var _boothContent = require('./booth-content');

var _boothContent2 = _interopRequireDefault(_boothContent);

var _boothButtons = require('./booth-buttons');

var _boothButtons2 = _interopRequireDefault(_boothButtons);

var _gridSizer = require('./grid-sizer');

var _gridSizer2 = _interopRequireDefault(_gridSizer);

var _welcomeVideo = require('../welcome-video/welcome-video');

var _welcomeVideo2 = _interopRequireDefault(_welcomeVideo);

var _showbagHelper = require('../helpers/showbag-helper');

var _showbagHelper2 = _interopRequireDefault(_showbagHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class Booth
 * A Booth displays interactive contents to show-goers
 * @prop {string} name - the name of the exhibitor
 * @prop {Array} contents - the booth contents
 * @prop {URLString} interior (optional) - an image of the booth to use as a background
 * @prop {URLString} welcomeVideo (optional) - a video to play when the booth loads
 * @prop {string} hallID (optional) - the hall this booth is displayed in.  If supplied,
 * a "Return to Hall" button is displayed.
 * @prop {boolean} exhibitorPreview (optional) - indicates the booth is being displayed as a
 * exhibitor preview.  If true, only the close navigation button is displayed.
 */
var Booth = function (_Component) {
  _inherits(Booth, _Component);

  function Booth(props) {
    _classCallCheck(this, Booth);

    return _possibleConstructorReturn(this, (Booth.__proto__ || Object.getPrototypeOf(Booth)).call(this, props));
  }
  /** @function componentWillMount
    * Starts the welcome video (if specified) and
    * display the booth name in the navigation bar
    */


  _createClass(Booth, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (window.vexpo && window.vexpo.navigation && window.vexpo.navigation.setLocationName) {
        window.vexpo.navigation.setLocationName(this.props.name);
      }
    }
    /** @function componentWillReceiveProps
      * Displays the booth name in the navigation bar
      */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (window.vexpo && window.vexpo.navigation && window.vexpo.navigation.setLocationName) {
        window.vexpo.navigation.setLocationName(this.props.name);
      }
    }
    /** @method
     * Renders the Booth component.
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var contents = (this.props.contents || []).map(function (item, index) {
        return _react2.default.createElement(_content2.default, _extends({ key: index, boothID: _this2.props.boothID }, item));
      });
      var masonryOptions = {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPostion: 'true',
        resize: 'true',
        disableImagesLoaded: true,
        updateOnEachImageLoad: false
      };
      var buttons = [];
      if (!this.props.exhibitorPreview) {
        buttons = [_react2.default.createElement(
          'button',
          { onClick: function onClick() {
              if (window.vexpo && window.vexpo.showLocations) window.vexpo.showLocations();
            } },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'map-signs' }),
          'LOCATIONS'
        ), _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/lobby' },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'home' }),
          'LOBBY'
        )];
        if (this.props.hallID) {
          buttons.push(_react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/halls/' + this.props.hallID },
            _react2.default.createElement(_reactFontawesome2.default, { name: 'flag' }),
            'HALL'
          ));
        }
      }
      var helper = this.props.preview ? "" : _react2.default.createElement(_showbagHelper2.default, null);
      return _react2.default.createElement(
        _boothBackground2.default,
        { image: this.props.interior },
        _react2.default.createElement(_welcomeVideo2.default, { video: this.props.welcomeVideo, identifier: this.props.boothID }),
        _react2.default.createElement(_boothShade2.default, null),
        _react2.default.createElement(
          _boothContent2.default,
          null,
          _react2.default.createElement(
            _boothButtons2.default,
            null,
            this.props.navLinks
          ),
          _react2.default.createElement(
            _reactMasonryComponent2.default,
            { options: masonryOptions },
            _react2.default.createElement(_gridSizer2.default, { className: 'grid-sizer' }),
            contents
          ),
          helper
        )
      );
    }
  }]);

  return Booth;
}(_react.Component);

exports.default = Booth;


Booth.propTypes = {
  name: _propTypes2.default.string.isRequired,
  contents: _propTypes2.default.array.isRequired,
  interior: _propTypes2.default.string,
  welcomeVideo: _propTypes2.default.string,
  hallID: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/booth/booth.js
// module id = 220
// module chunks = 0